import { useQuery, queryOptions } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { ServiceCode } from '@/types'

export async function readCompanyServiceCode(company_key: string) {
  const response = await httpClient('accounting-dealer').get<ServiceCode[]>(
    `/v3/company/${company_key}/service-code`,
  )

  return response.data
}

export const readCompanyServiceCodeOptions = (company_key: string) =>
  queryOptions({
    queryKey: ['company-service-code', company_key],
    queryFn: () => readCompanyServiceCode(company_key),
  })

export function useReadCompanyServiceCode(company_key: string) {
  return useQuery(readCompanyServiceCodeOptions(company_key))
}
